'use client'

import Link from 'next/link'
import { track } from '@/utils/analytics'
import { INGREDIENT_METHOD_VERSION } from '@/app/microplastic-ingredients/_data/evidence'

export default function BrandCheckerLink({ brandSlug, position }: { brandSlug?: string; position: 'answer' | 'bottom' }) {
  return <Link
    href="/microplastic-ingredient-checker"
    onClick={() => track('related_article_click', {
      cta_surface: 'brand_ingredient_checker', destination: '/microplastic-ingredient-checker',
      destination_type: 'web_tool', page_type: brandSlug ? 'brand_detail' : 'brands_hub',
      brand_slug: brandSlug, cta_position: position, method_version: INGREDIENT_METHOD_VERSION,
    })}
    className="mt-5 inline-flex rounded-control bg-forest px-5 py-3 font-semibold text-white"
  >Check ingredient names on your label</Link>
}
